<template>
    <div class="fill flex-box col" :class="!max_flag?'max-body-width':''">
        <slot name="header"></slot>
        <div v-if="!$slots.body" class="flex-box-bd fullw tleft" style="overflow-y: auto;overflow-x: hidden;padding: 0 5px">
            <slot></slot>
        </div>
        <slot name="body"></slot>
        <slot name="footer"></slot>
    </div>
</template>

<script>
    export default {
        name: "myPage",
        components:{
        },
        props:{
            show_header: {
                default: true,
                type: Boolean,
            },
            max_flag: {
                default: false,
                type: Boolean,
            }
        },
        methods:{
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myPage.vue